module.exports = __webpack_public_path__ + "static/media/tartine-map-small.0665c4f2.png";